<template>
<div>
    <messaging :display="message.display" :top="true" :text="message.text" :timeout="message.timeout" v-on:closed="message.display=false"/>
    <userFormRegister 
        v-on:save="register_user"
        v-on:site_regulation="siteRegulation"
        :programId="programId"
        :userEmail="userEmail"
        />
</div>
</template>

<script>
import userFormRegister from '@/components/Forms/userFormRegister.vue';
import HubspotReflectionPoolHandler from '@/Controllers/helper/HubspotReflectionPoolHandler.js'
export default {
    name: "Registration",
    components: {
        userFormRegister
    },
    props: {
        programId : {
            type: Number,
            required: false,
            default: 0
        },
        userEmail: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function(){
        return {
            message: {
                display: false,
                text: 'sample text',
                timeout: null
            },
            validationState: {
                registrationForm: false
            }
        }
    },
    methods: {
        register_user: function(data){
            let self = this;
            this.validationState.registrationForm = data.validation_state;
            if (this.validationState.registrationForm){
                let dataToHubspotFeed = {...data.user}
                let hubspotFeedEventTyp = 'registration'
                if (data.target_program!==undefined && data.target_program){
                    let joinedProgramDetails = self.$store.getters.programs.filter(program => program.id==data.target_program)
                    if (joinedProgramDetails.length>0){
                        dataToHubspotFeed['program'] = joinedProgramDetails[0].reference;
                        dataToHubspotFeed['program_id'] = joinedProgramDetails[0].id;
                        hubspotFeedEventTyp = 'registration_user_joined_program'
                    }
                }
                this.$controller.security.user.register(data.user, data.target_program).then(function(response){
                    if(response.status==200 && response.data.security.register.result===true){
                        self.customCLog('registration success');
                        let hubspotFeed = HubspotReflectionPoolHandler.event.addFeed(dataToHubspotFeed, hubspotFeedEventTyp, self);
                        if (self.$route.meta.hashCodeVerificationRequired){
                            let userProgramRegistrationCodeUsageState = self.$controller.program.setUserProgramRegistrationCodeUsageState(self.$route.params.registrationHashCode, 'Y')
                        }
                    }else{
                        self.customCLog('registration failure',{
                            error_types: ['account already exists','missing required info']
                        }, true);
                    }
                    
                    self.$emit('registration_result', response);
                });
            }
        },
        siteRegulation: function(target){
            this.$emit('site_regulation', target);
        }
                  
    }
}
</script>

<style>

</style>